import React, { useState } from 'react';
import { Button, Flex } from 'antd';
import axios from 'axios';
import logo from './logo.svg';
import beianLogo from './beian.png'
import './App.css';


function App() {
  const [data, setData] = useState("------");

  function getCode(){
    axios.get('https://goodmorningandhi.com/getcode')
      .then(response => {
        setData(response.data.data);
        console.log(response.data);
      })
      .catch(error => {
        // 处理错误
        setData("Something error");
        console.log(error);
      });
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          {data}
        </p>
        <Button type="primary" onClick={getCode}>获取验证码</Button>
        <Flex style={{paddingTop:"30px"}} vertical>
          <span
            style={{
              fontSize: '13px',
              color: "#939393"
            }}
          >© 2022-2023 goodmorningandhi.com 版权所有</span>
          <Flex>
            <div>
              <a 
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43011102002303"
                style={{
                  display: 'inline-block',
                  textDecoration:'none',
                  color:'#939393',
                  backgroundImage: `url(${beianLogo})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 0,
                  fontSize: '12px',
                  paddingLeft: '20px'
                }}
              >
                <span>湘公网安备 43011102002303号</span>
              </a>
            </div>
            <div>
              <a 
                style={{
                  display:'inline-block',
                  textDecoration:'none',
                  fontSize:'12px',
                  color:'#939393',
                  paddingLeft: '6px'
                }}
              href="https://beian.miit.gov.cn/"
              target="_blank"
              >湘ICP备2023000042号-2</a>
            </div>
          </Flex>
        </Flex>
      </header>
    </div>
  );
}

export default App;
